export default {
  tooltipsForScreensize(state, getters, rootState) {
    return state.tooltips.filter(tip =>
      tip.type.includes(rootState.app.screenSize.split('_')[0])
    );
  }
};
